import React, { useContext } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  CANCELLATION_TYPE,
  DATE_FORMATS,
  USER_ROLES,
  ORDER_STATUS,
} from '../../../../../common/constants';
import { formatDate } from '../../../../../common/utils';
import ModalComponent from '../../../../../components/ModalComponent';

const NoteModal = ({
  note,
  isModalOpen,
  setIsModalOpen,
  isOrderAction,
  adminNote,
  order,
}) => {
  const { getCurrentUser } = useContext(AppContext);
  const { roles } = getCurrentUser() || {};

  const activeOrder = isOrderAction ? order : null;
  const isNotDelivered =
    activeOrder?.status === ORDER_STATUS?.NOT_DELIVERED?.value &&
    !!activeOrder?.metadata?.notDeliveredReason;
  const partnerData =
    activeOrder?.deliveryPartner || activeOrder?.metadata?.deliveryStaffDetails;
  const riderName = partnerData
    ? `${partnerData?.firstName || partnerData?.name || ''} ${
        partnerData?.lastName || ''
      }`.trim()
    : '';

  const notDeliveredHistory = activeOrder?.statusHistory?.find(
    (history) => history?.newStatus === ORDER_STATUS?.NOT_DELIVERED?.value,
  );
  const notDeliveredDate = notDeliveredHistory?.createdAt;

  return (
    <ModalComponent
      open={isModalOpen}
      onCancel={() => {
        setIsModalOpen(false);
      }}
      footer={null}
    >
      {(note || isNotDelivered) && (
        <>
          {isNotDelivered && (
            <>
              <div className="mb-8">
                <b className="font-size-16">
                  Not Delivered by {riderName || '-'}
                </b>
              </div>
              {notDeliveredDate && (
                <div className="font-size-16">
                  Date: {formatDate(notDeliveredDate, DATE_FORMATS?.REGULAR)}
                </div>
              )}
              <div className="font-size-16">
                Reason: {activeOrder?.metadata?.notDeliveredReason || '-'}
              </div>
            </>
          )}
          {note && (
            <>
              {note?.type === CANCELLATION_TYPE?.LIBRARY?.value && (
                <div className="mb-8">
                  <b className="font-size-16">Comment By Library</b>
                </div>
              )}
              {note?.type === CANCELLATION_TYPE?.USER?.value &&
                !roles?.includes(USER_ROLES?.LIBRARIAN?.key) && (
                  <div className="mb-8">
                    <b className="font-size-16">Cancelled By End-user</b>
                  </div>
                )}
              {note?.type === CANCELLATION_TYPE?.ADMIN?.value && (
                <div className="mb-8">
                  <b className="font-size-16">Cancelled By Admin</b>
                </div>
              )}
              {note?.date && (
                <div className="font-size-16">
                  Date: {formatDate(note?.date, DATE_FORMATS?.REGULAR)}
                </div>
              )}
              {(note?.type === CANCELLATION_TYPE?.API?.value ||
                note?.type === CANCELLATION_TYPE?.QUEUE?.value ||
                note?.type === CANCELLATION_TYPE?.ADLOGGS?.value ||
                note?.type === CANCELLATION_TYPE?.PAYMENT?.value) &&
                !roles?.includes(USER_ROLES?.LIBRARIAN?.key) && (
                  <>
                    <div className="font-size-16">
                      Type: {CANCELLATION_TYPE?.[note?.type]?.label || '-'}
                    </div>
                    <div className="font-size-16">
                      Reason: {note?.reason || '-'}
                    </div>
                  </>
                )}
              {(note?.type === CANCELLATION_TYPE?.LIBRARY?.value ||
                note?.type === CANCELLATION_TYPE?.ADMIN?.value) &&
                isOrderAction && (
                  <>
                    <div className="font-size-16">
                      Reason for cancellation: {note?.reason || '-'}
                    </div>
                    <div className="font-size-16 text-justify">
                      Additional comment: {note?.additionalComment || '-'}
                    </div>
                  </>
                )}
              {note?.type === CANCELLATION_TYPE?.LIBRARY?.value && !isOrderAction && (
                <>
                  <div className="font-size-16">
                    Reason for not fulfilling the order: {note?.reason || '-'}
                  </div>
                  <div className="font-size-16 text-justify">
                    Additional comment: {note?.additionalComment || '-'}
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
      {adminNote && !roles?.includes(USER_ROLES?.LIBRARIAN?.key) && (
        <div
          className={
            note || isNotDelivered
              ? 'mt-16'
              : 'mt-8'
          }
        >
          <div className="mb-8">
            <b className="font-size-16">Resolving comment by admin</b>
          </div>
          <div className="font-size-16">{adminNote || '-'}</div>
        </div>
      )}
    </ModalComponent>
  );
};

export default NoteModal;
